import { makeStyles, shorthands, tokens, type GriffelStyle } from "@fluentui/react-components";
import { contentColumn, contentScroll, pageMax, pageMin, pageNarrowAt, pagePairAt, pageStackAt } from "@/shell/content-frame";

/**
 * 요약·분석·리포트가 함께 쓰는 Visual 크롬(카드·머리·제목·메타).
 * 카드는 1px Stroke2 테두리만 쓰고 그림자는 두지 않는다(ui-style §2, ui-principles).
 */
export const visualCard: GriffelStyle = {
  position: "relative",
  backgroundColor: tokens.colorNeutralBackground1,
  borderRadius: tokens.borderRadiusMedium,
  ...shorthands.border("1px", "solid", tokens.colorNeutralStroke2),
  padding: `${tokens.spacingVerticalM} ${tokens.spacingHorizontalL}`,
  display: "flex",
  flexDirection: "column",
  gap: tokens.spacingVerticalS,
  boxSizing: "border-box",
  minWidth: 0,
};

export const visualHead: GriffelStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: tokens.spacingHorizontalM,
  minHeight: "24px",
};

export const visualTitle: GriffelStyle = {
  fontSize: tokens.fontSizeBase300,
  lineHeight: tokens.lineHeightBase300,
  color: tokens.colorNeutralForeground1,
  fontWeight: tokens.fontWeightRegular,
};

export const visualMeta: GriffelStyle = {
  fontSize: tokens.fontSizeBase200,
  lineHeight: tokens.lineHeightBase200,
  color: tokens.colorNeutralForeground3,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  minWidth: 0,
};

/** 「무엇을 읽는지」 한 줄 설명. 넘치면 말줄임(전문은 title). */
export const visualDescription: GriffelStyle = {
  fontSize: tokens.fontSizeBase200,
  lineHeight: tokens.lineHeightBase200,
  color: tokens.colorNeutralForeground3,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  minWidth: 0,
};

/** 페이지 본문. 스크롤은 웰 폭이고, 제목과 내용은 1180 컬럼이다. */
export const useVisualPageStyles = makeStyles({
  body: contentScroll,
  wrap: contentColumn,
  grid2: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: tokens.spacingHorizontalM,
    [pageMax(pageStackAt)]: { gridTemplateColumns: "1fr" },
  },
  grid3: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: tokens.spacingHorizontalM,
    [pageMin(pageNarrowAt)]: { gridTemplateColumns: "repeat(2, minmax(0, 1fr))" },
    [pageMin(pagePairAt)]: { gridTemplateColumns: "repeat(3, minmax(0, 1fr))" },
  },
});
